import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import Logo from './Logo'
import Sidebar from './Sidebar'
import Container from './Container'

const Layout = ({ children }) => (
  <Container>
    <LogoWrapper to="/">
      <Logo />
    </LogoWrapper>
    <MainContent>
      <SidebarContainer>
        <Sidebar />
      </SidebarContainer>
      {children}
    </MainContent>
  </Container>
)

const SidebarContainer = styled.div`
  height: 80%;
  margin-top: 100px;
  display: flex;
  align-items: center;
  position: fixed;
`

const MainContent = styled.main`
  display: flex;
  height: 80vh !important;
`

const LogoWrapper = styled(Link)`
  position: fixed;
  z-index: 2;
  padding-left: 13px;
`

export default Layout
